var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthnaOffBgMobileMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 300,
    viewBox: "0 0 357 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0 10.7452 10.7452 0 24 0H333C346.255 0 357 10.7452 357 24V162C357 175.255 346.255 186 333 186H187C164.909 186 147 203.909 147 226V241.5C147 255.031 136.031 266 122.5 266V266C108.969 266 98 255.031 98 241.5V210.5C98 196.969 87.031 186 73.5 186V186C59.969 186 49 196.969 49 210.5V275.5C49 289.031 38.031 300 24.5 300V300C10.969 300 0 289.031 0 275.5V162V118V24Z",
    fill: "url(#paint0_linear_14_316)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_316",
    x1: 31.5328,
    y1: -47.6435,
    x2: 309.555,
    y2: 401.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319327,
    stopColor: "#F84CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904445,
    stopColor: "#FFE600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthnaOffBgMobileMd);
export default __webpack_public_path__ + "static/media/ethna_off_bg_mobile_md.40bbf599bf76a9da9d1549a2795eb2bd.svg";
export { ForwardRef as ReactComponent };